export default "/images/kultsna.png?c460062ae29cfb7d7883fdf1a5a723f2";